import React from 'react';
import { Form, Table, Input } from 'semantic-ui-react';
import * as _ from 'lodash';
import memoizeOne from 'memoize-one';
import CustomDropdown from '../../../../common/CustomDropdown';
import { APPROVAL_OPTIONS, GLOBAL_APPROVAL_STATUS, APPROVAL_FLOW_TYPES } from '../../../../../HelperMethods/enums';

const getApprovalOptions = memoizeOne((approvalOptions) => {
  const options = [];
  const approvalOptionList = Object.values(APPROVAL_OPTIONS);
  const approvalOptionDict = _.keyBy(approvalOptionList, 'key');
  for (const option of approvalOptions) {
    const reqOption = approvalOptionDict[option];
    if (reqOption) {
      const { label, key, status, statusText } = reqOption;
      const optionObj = { key, text: statusText, value: status, content: label };
      options.push(optionObj);
    }
  }
  return options;
});

const getApproversOptions = memoizeOne((approvers) => {
  const options = [];
  for (const approver of approvers) {
    const { id, name } = approver;
    options.push({ key: id, value: id, text: name });
  }
  return options;
});

const checkIfActionIsDisabled = ({ loggedInUserId, matrix, approver, approverIndex }) => {
  const { approvers, approvalStatus } = approver;
  const { allowChangesPostApprovalOrDeny, approvalFlowType, isApprovalLimitCrossed } = matrix;
  // logged user should be in approver
  if (isApprovalLimitCrossed) {
    return true;
  }
  if (!approvers.find((val) => val.selected && val.id === loggedInUserId)) {
    return true;
  }
  // don't allow action allowchanges=false when status is approved or deny
  if (
    !allowChangesPostApprovalOrDeny &&
    (approvalStatus === GLOBAL_APPROVAL_STATUS.APPROVED.key || approvalStatus === GLOBAL_APPROVAL_STATUS.DENIED.key)
  ) {
    return true;
  }
  // in series zero index always allowed others allowed after upper is done
  if (approvalFlowType === APPROVAL_FLOW_TYPES.SERIES.key) {
    if (approverIndex === 0) {
      return false;
    }
    if (matrix.approvers[approverIndex - 1].approvalStatus === GLOBAL_APPROVAL_STATUS.PENDING_APPROVAL.key) {
      return true;
    }
  }
  return false;
};

const MatrixInfoComponent = ({ formik, ...props }) => {
  const { handleAction } = props;
  const handleApprover = ({ approver, value, approverIndex, matrixIndex }) => {
    const clonedApprover = _.cloneDeep(approver);
    for (const user of clonedApprover.approvers) {
      if (value.includes(user.id)) {
        user.selected = true;
      } else {
        user.selected = false;
      }
    }
    const approval = _.cloneDeep(_.get(formik, 'values.approval_matrixInfo', []));
    approval[matrixIndex].approvers[approverIndex] = clonedApprover;
    formik.setFieldValue('approval_matrixInfo', approval, false);
  };

  return (
    <>
      {_.get(formik, 'values.approval_matrixInfo', []) && _.get(formik, 'values.approval_matrixInfo', []).length > 0 ? (
        <Table id="partsTable">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Approval Type</Table.HeaderCell>
              <Table.HeaderCell>Approver</Table.HeaderCell>
              <Table.HeaderCell width={1}>Approval Limit</Table.HeaderCell>
              <Table.HeaderCell width={2}>Action</Table.HeaderCell>
              <Table.HeaderCell width={2}>Comment</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {_.get(formik, 'values.approval_matrixInfo', []).map((matrix, matrixIndex) =>
            _.get(matrix, 'approvers', []).map((approver, approverIndex) => {
              return (
                <Table.Body key={`${matrix.attributeKey}_${approver.approverLimit}`}>
                  <Table.Row>
                    <Table.Cell>
                      <Form.Field>
                        <label>{matrix.displayName}</label>
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        <CustomDropdown
                          placeholder="Choose Approver"
                          search
                          selection
                          name="approver"
                          value={approver.approvers.filter((user) => user.selected).map((user) => user.id)}
                          options={getApproversOptions(approver.approvers)}
                          multiple
                          onChange={(event, { value }) => {
                            handleApprover({ approver, value, event, approverIndex, matrixIndex });
                          }}
                        />
                        {_.get(formik, `errors.approval_matrixInfo[${matrixIndex}].approvers[${approverIndex}]`) && (
                          <div className="errorText">
                            *{_.get(formik, `errors.approval_matrixInfo[${matrixIndex}].approvers[${approverIndex}]`)}
                          </div>
                        )}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        <label>{approver.approverLimit}</label>
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        <CustomDropdown
                          placeholder="Action"
                          search
                          selection
                          name="action"
                          value={approver.approvalStatus}
                          options={getApprovalOptions(matrix.approvalOptions, approver.approvalStatus)}
                          onChange={(event, data) => {
                            handleAction({
                              event,
                              data,
                              approverIndex,
                              matrixIndex,
                              statusForApprovalLimit: approver.approvalStatus,
                            });
                          }}
                          disabled={checkIfActionIsDisabled({
                            matrix,
                            approver,
                            loggedInUserId: props.loggedInUser.id,
                            approverIndex,
                          })}
                          selectOnBlur={false}
                        />
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field style={{ width: '150px' }}>
                        <div title={approver.comment}>
                          <Input disabled value={(approver.comment || '').substring(0, 18)} />
                        </div>
                      </Form.Field>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              );
            })
          )}
        </Table>
      ) : null}
    </>
  );
};

export default MatrixInfoComponent;
